module.exports = __webpack_public_path__ + "static/media/Mobile_Numbers2.c60979f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewcc/Mobile_Numbers2.png
// module id = 104
// module chunks = 0